import { skipToken, useQuery } from '@tanstack/react-query'
import type { ReturnsApiProductDetailsRequest } from '@itsrever/rever-api'
import { returnsApi } from '@/redux/api/store-api-slice'
import { hasVariantStock } from '@/app/full-catalog/helpers/has-variant-stock'

export const useStoreProductDetails = ({
  ecommerceId,
  productId,
  language,
  currency,
  countryCode,
  orderReference
}: Partial<ReturnsApiProductDetailsRequest>) => {
  return useQuery({
    queryKey: [
      'product-details',
      ecommerceId,
      productId,
      language,
      currency,
      countryCode,
      orderReference
    ],
    queryFn:
      ecommerceId !== undefined && productId !== undefined
        ? async () => {
            const { data } = await returnsApi.productDetails({
              ecommerceId,
              productId,
              language,
              currency,
              countryCode,
              orderReference
            })

            return data
          }
        : skipToken,
    staleTime: 60 * 1000 * 2, // 2 minutes
    select: (data) => ({
      ...data,
      product_info: {
        ...data.product_info,
        variants: data.product_info?.variants
          ? data.product_info?.variants.sort((a, b) => {
              const aHasStock = hasVariantStock(a)
              const bHasStock = hasVariantStock(b)

              if (aHasStock === bHasStock) return 0
              return aHasStock ? -1 : 1
            })
          : undefined
      }
    })
  })
}
